import CRUDTableComponent from '../../components/CRUDTableComponent'

const HealthInsurancesTable = () => {
  const tableColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      type: 'string',
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
  ]

  return (
    <CRUDTableComponent
      entityName={{ plural: 'Isapres', singular: 'Isapre' }}
      tableColumns={tableColumns}
      entityUrl="/health-insurances?sortBy=name"
    />
  )
}

export default HealthInsurancesTable
